import cn from 'classnames';

import AutoBlurButton from 'components/common/AutoBlurButton';
import CaretLeft from 'components/icons/navigation/CaretLeft';
import CaretRight from 'components/icons/navigation/CaretRight';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const ScrollArrows = ({
  backButtonStyles = 'left-2',
  buttonStyles = 'h-[3em] w-[3em] -translate-y-[3em] top-1/2',
  forwardButtonStyles = 'right-2',
  iconStyles = 'iconLg',
  iconColorStyles = '',
  showPrev,
  showNext,
  scrollLeft,
  scrollRight,
}) => {
  const isTempo = useBrand(TEMPO);
  const navButtonStyles =
    'absolute rounded-full bg-ice-100 transition-all duration-200 hover:bg-charcoal-60';

  const iconColor = iconColorStyles
    ? iconColorStyles
    : isTempo
      ? 'text-tempo-blue-90'
      : 'text-green-100';

  return (
    <>
      {showPrev && (
        <AutoBlurButton
          className={cn('hover:shadow-lg', navButtonStyles, buttonStyles, backButtonStyles)}
          onClick={scrollLeft}
        >
          <span className="sr">Previous</span>
          <CaretLeft className={cn(iconStyles, iconColor)} />
        </AutoBlurButton>
      )}
      {showNext && (
        <AutoBlurButton
          className={cn('hover:shadow-lg', navButtonStyles, buttonStyles, forwardButtonStyles)}
          onClick={scrollRight}
        >
          <span className="sr">Next</span>
          <CaretRight className={cn(iconStyles, iconColor)} />
        </AutoBlurButton>
      )}
    </>
  );
};

export default ScrollArrows;

ScrollArrows.propTypes = {
  backButtonStyles: PropTypes.string,
  buttonStyles: PropTypes.string,
  forwardButtonStyles: PropTypes.string,
  iconStyles: PropTypes.string,
  iconColorStyles: PropTypes.string,
  showPrev: PropTypes.bool.isRequired,
  showNext: PropTypes.bool.isRequired,
  scrollLeft: PropTypes.func.isRequired,
  scrollRight: PropTypes.func.isRequired,
};
